<template>
  <v-row justify="center" align="center" class="skewed-bg">
    <v-col cols="12" sm="11" md="10" lg="10" style="z-index:1">
      <v-card>
        <!-- {{ content }} -->
        <v-container>
          <v-card-title>
            <span class="text_title_2">ตอบกลับอีเมล</span>
          </v-card-title>
          <v-form ref="form" @submit.prevent="sendMail">
            <v-row justify="center" align="center">
              <v-col cols="12" sm="11" md="10" class="py-0">
                <v-container>
                  <v-row justify="center" align="center">
                    <v-col cols="12" class="py-0">
                      <v-row>
                        <v-col
                          md="2"
                          sm="2"
                          cols="12"
                          :align="mobile ? null : 'right'"
                          class="py-0"
                        >
                          <span class="text_body_5">ถึง</span>
                        </v-col>
                        <v-col md="10" sm="10" cols="12" class="py-0">
                          <v-text-field
                            dense
                            outlined
                            readonly
                            v-model="receiver"
                            placeholder="ถึง"
                            :rules="rule_empty"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <v-row>
                        <v-col
                          md="2"
                          sm="2"
                          cols="12"
                          :align="mobile ? null : 'right'"
                          class="py-0"
                        >
                          <span class="text_body_5">เรื่อง</span>
                        </v-col>
                        <v-col md="10" sm="10" cols="12" class="py-0">
                          <v-text-field
                            dense
                            outlined
                            v-model="title"
                            placeholder="เรื่อง"
                            single-line
                            :rules="rule_empty"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <v-row>
                        <v-col
                          md="2"
                          sm="2"
                          cols="12"
                          :align="mobile ? null : 'right'"
                          class="py-0"
                        >
                          <span class="text_body_5">ข้อความ</span>
                        </v-col>
                        <v-col md="10" sm="10" cols="12" class="pt-0">
                          <quill-editor
                            ref="myTextEditor"
                            class="ql-container ql-formats"
                            v-model="content"
                            :options="editorOption"
                            @blur="onEditorBlur($event)"
                            @focus="onEditorFocus($event)"
                            @ready="onEditorReady($event)"
                          ></quill-editor>
                          <span
                            style="margin-top:-10px"
                            v-if="require_content"
                            class="text_body_6 error--text ml-3"
                            >* กรุณากรอกข้อมูล</span
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" align="right">
                      <v-btn
                        tile
                        :loading="btn_loading"
                        :large="!mobile"
                        :block="mobile"
                        color="primary"
                        dark
                        type="submit"
                      >
                        <span class="text_body_4 mt-1">ส่ง</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import hljs from "highlight.js";
import { isEmptyTextField } from "../../../assets/javascript/rules";

export default {
  data() {
    return {
      header_token: {
        headers: {
          token: this.$session.get("token_roy"),
        },
      },
      btn_loading: false,
      rule_empty: isEmptyTextField,
      receiver: "",
      title: "ขอบคุณสำหรับช่องทางเสนอคำทับศัพท์เพิ่มเติม",
      content:
        "<p>ขอบคุณสำหรับการเสนอคำทับศัพท์ ทางเราจะนำคำคำทับศัพท์ของคุณไปพิจารณาต่อเพื่อเป็นประโยชน์ในการพัฒนาระบบต่อไป</p><p><br></p><p><br></p><p><br></p><p><br></p><p class='ql-align-right'>ขอบคุณค่ะ</p>",
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            // ["blockquote", "code-block"],
            // [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            // [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            // [{ direction: "rtl" }],
            // [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            // [{ font: [] }],
            // [{ color: [] }, { background: [] }],
            [{ align: [] }],
            // ["clean"],
            // ["link", "image", "video"],
          ],
          syntax: {
            highlight: (text) => hljs.highlightAuto(text).value,
          },
        },
      },
      requestWordId: null,
      require_content: false,
    };
  },
  watch: {
    content(val) {
      if (val) {
        this.require_content = false;
      } else {
        this.require_content = true;
      }
    },
  },
  computed: {
    mobile() {
      if (
        this.$vuetify.breakpoint.width >= 320 &&
        this.$vuetify.breakpoint.width < 768
      ) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (
        this.$vuetify.breakpoint.width >= 768 &&
        this.$vuetify.breakpoint.width < 1440
      ) {
        return true;
      } else {
        return false;
      }
    },
    desktop() {
      if (this.$vuetify.breakpoint.width >= 1440) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    this.receiver = this.$route.query.email;
    this.requestWordId = this.$route.query.id;
  },
  methods: {
    sendMail() {
      if (this.content) {
        this.require_content = false;
      } else {
        this.require_content = true;
      }
      if (this.$refs.form.validate() && this.require_content == false) {
        this.btn_loading = true;
        var data = {
          message: this.content,
          topic: this.title,
        };
        this.axios
          .post(
            process.env.VUE_APP_API +
              "api/v1/admin/requestWord/" +
              this.requestWordId +
              "/mail/reply",
            data,
            this.header_token
          )
          .then((res) => {
            // console.log(res.data);
            if (res.data == "send mail success") {
              this.$swal.fire({
                icon: "success",
                title: "ส่งข้อความสำเร็จ",
                showConfirmButton: false,
                timer: 1000,
              });
              this.goRequestPage();
            } else {
              this.$swal.fire({
                icon: "error",
                title: "ผิดพลาด กรุณาลองใหม่อีกครั้ง",
              });
              this.goRequestPage();
            }
          });
      }
    },
    goRequestPage() {
      this.$router.push("/requestword");
      this.btn_loading = false;
    },
    onEditorBlur(quill) {
      // console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      // console.log("editor focus!", quill);
    },
    onEditorReady(quill) {
      // console.log("editor ready!", quill);
    },
    onEditorChange({ quill, html, text }) {
      // console.log("editor change!", quill, html, text);
      this.content = html;
    },
  },
};
</script>
<style lang="scss">
.skewed-bg {
  background: #e9f1fe;
  color: #fff;
  padding: 2em;
  position: relative;
  min-height: 300px;
  overflow: hidden;
  z-index: 0;
}
.skewed-bg::after {
  content: "";
  position: absolute;
  top: 200px;
  left: 0;
  right: 0;
  height: 100%;
  background: #fff;
  transform: skew(0deg, 0deg);
  z-index: 0;
}
.ql-toolbar {
  background-image: linear-gradient(to top, #e5e5e5, white);
}

.ql-toolbar.ql-snow .ql-formats {
  margin-right: 15px;
  margin-bottom: 5px;
  border: 1px solid #bec0c2;
}
.quill-code {
  border: none;
  height: auto;
  > code {
    width: 100%;
    margin-top: 50px;
    padding: 1rem;
    border: 1px solid #ccc;
    border-top: none;
    border-radius: 0;
    height: 10rem;
    overflow-y: auto;
    resize: vertical;
  }
}
.ql-toolbar.ql-snow + .ql-container.ql-snow {
  border-top: 0px;
  height: 250px;
}
</style>
